/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsSolidChatBubbleLeft = ({ className }) => {
  return (
    <svg
      className={`heroicons-solid-chat-bubble-left ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M3.42976 2.52374C5.56943 2.17905 7.76407 2 10 2C12.2359 2 14.4306 2.17905 16.5702 2.52374C18.0066 2.75513 19 4.01325 19 5.42588V10.5741C19 11.9867 18.0066 13.2449 16.5702 13.4763C14.8747 13.7494 13.1447 13.9185 11.3869 13.977C11.1832 13.9837 10.9953 14.0654 10.8594 14.2013L7.28033 17.7803C7.06583 17.9948 6.74324 18.059 6.46299 17.9429C6.18273 17.8268 6 17.5533 6 17.25V13.8073C5.13517 13.7236 4.27814 13.6129 3.42976 13.4763C1.99339 13.2449 1 11.9868 1 10.5741V5.42588C1 4.01325 1.99339 2.75513 3.42976 2.52374Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
